/** Coerce a phone number to E.164 for Twilio (strips spaces/parens/dashes).
 *  "+1 (305) 725-6305" -> "+13057256305"; a bare 10-digit number assumes +1. */
export function normalizePhone(input: string): string {
  let v = (input || '').replace(/[^\d+]/g, '');
  v = v.replace(/(?!^)\+/g, ''); // keep only a leading +
  if (!v.startsWith('+')) v = v.length === 10 ? `+1${v}` : `+${v}`;
  return v;
}
